import { FC } from 'react'
import { DiscountsList } from 'components/Discounts'
import { UserProtectedRoute } from 'routes'

// Index route of /discounts — the grid is the main content on both breakpoints.
const DiscountsPage: FC = () => (
  <UserProtectedRoute>
    <DiscountsList />
  </UserProtectedRoute>
)

export default DiscountsPage
